import { reducerWithInitialState } from "typescript-fsa-reducers";

import { MegaphoneLocation, MegaphoneApiData } from "../api/megaphones";
import { Megaphone, loadMegaphones, openMegaphone, closeMegaphone, clickMegaphone } from "../actions/Megaphones";

export type MegaphonesState = { [key in MegaphoneLocation]?: Megaphone | null };

const initialState: MegaphonesState = {};

function setUpMegaphone(data: MegaphoneApiData): Megaphone {
  return {
    ...data,
    isOpened: false,
    isClosed: false,
    isClicked: false,
  };
}

const megaphonesReducer = reducerWithInitialState(initialState)
  .case(loadMegaphones.done, (state, { result: megaphones }) => {
    const newState: MegaphonesState = {};
    Object.entries(megaphones).forEach(([location, data]) => {
      if (data) {
        newState[location as MegaphoneLocation] = setUpMegaphone(data);
      }
    });
    return { ...state, ...newState };
  })
  .case(openMegaphone.done, (state, { result: location }) => {
    const newMegaphone: Megaphone = { ...state[location as MegaphoneLocation]!, isOpened: true };
    return { ...state, [location]: newMegaphone };
  })
  .case(closeMegaphone.done, (state, { result: location }) => {
    const newMegaphone: Megaphone = { ...state[location as MegaphoneLocation]!, isClosed: true };
    return { ...state, [location]: newMegaphone };
  })
  .case(clickMegaphone.done, (state, { result: location }) => {
    const newMegaphone: Megaphone = { ...state[location as MegaphoneLocation]!, isClicked: true };
    return { ...state, [location]: newMegaphone };
  });

export default megaphonesReducer;



// WEBPACK FOOTER //
// ./frontend/src/common/reducers/megaphones.ts